import { Flex, Typography, theme } from 'antd';
import { FC } from 'react';
import { CheckCircleFill, ExclamationTriangleFill, QuestionCircleFill } from 'react-bootstrap-icons';

import { SearchConsoleUrlInspection } from '@/modules/DomainsApi';

interface Props {
  indexingState: NonNullable<SearchConsoleUrlInspection['indexStatusResult']>['indexingState'] | null;
}

export const IndexingStateLabel: FC<Props> = ({ indexingState }) => {
  const { token: { colorSuccess, colorTextSecondary, colorWarning } } = theme.useToken();

  if (indexingState) {
    if (indexingState === 'INDEXING_ALLOWED') {
      return <Flex align="center"><CheckCircleFill color={ colorSuccess }/>&nbsp;Індексація дозволена</Flex>;
    }
    if (indexingState === 'INDEXING_STATE_UNSPECIFIED') {
      return <Flex align="center"><QuestionCircleFill color={ colorTextSecondary }/>&nbsp;Невідомий статус індексації</Flex>;
    }
    if (indexingState === 'BLOCKED_BY_HTTP_HEADER') {
      return <Flex align="center">
        <ExclamationTriangleFill color={ colorWarning }/>
        &nbsp;
        Індексація не дозволена, виявлено &#39;noindex&#39; у заголовку <strong>http</strong> &#39;X-Robots-Tag&#39;.
      </Flex>;
    }
    if (indexingState === 'BLOCKED_BY_META_TAG') {
      return <Flex align="center">
        <ExclamationTriangleFill color={ colorWarning }/>
        &nbsp;
        Індексація не дозволена, у мета-тезі <strong>robots</strong> виявлено &#39;noindex&#39;.
      </Flex>;
    }
  } else {
    return <Typography.Text>(недоступно)</Typography.Text>;
  }
};
